// extracted by mini-css-extract-plugin
module.exports = {"PricingCard":"ProductCard_PricingCard__1QQxd","CheckCircle":"ProductCard_CheckCircle__2fFWY"};